export const resolveComponentUi = <TSlots extends Record<string, (slotProps?: Record<string, unknown>) => string>>(
    slots: TSlots
): Record<keyof TSlots, string> =>
    Object.fromEntries(Object.entries(slots).map(([slot, resolve]) => [slot, resolve()])) as Record<
        keyof TSlots,
        string
    >;
